import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataNotification: {
    patient: {},
    location: {},
    symptoms: [],
    client_user_info: {},
  },
  calendar: {
    events: [],
  },
};

const doctorSlice = createSlice({
  name: "doctor",
  initialState,
  reducers: {
    setStatusArrive: (state, { payload }) => {
      state.dataNotification.status = payload.status;
      state.dataNotification.doctor_should_arrive_at = payload.arrive;
    },
    setCalendarEvents: (state, { payload }) => {
      state.calendar.events = payload;
    },
    updateRequestOnListDoctor: (state, { payload }) => {
      if (payload.allRead) {
        state.calendar.events = state.calendar.events.map((event) => ({
          ...event,
          service_request_chat: {
            ...event.service_request_chat,
            has_unread_messages: false,
          },
        }));
        return;
      }
      state.calendar.events = state.calendar.events.map((event) =>
        event.uuid === payload.uuid
          ? {
              ...event,
              service_request_chat: {
                ...event.service_request_chat,
                has_unread_messages: payload.mess,
              },
            }
          : event,
      );
    },
    clearAllDataDoctor: () => initialState,
  },
});

export const {
  setStatusArrive,
  setCalendarEvents,
  updateRequestOnListDoctor,
  clearAllDataDoctor,
} = doctorSlice.actions;

export const setStatusAndArrive = (status, arrive) =>
  setStatusArrive({ status, arrive });

export const doctorReducer = doctorSlice.reducer;
export default doctorReducer;
